import ibsStore from '../../components/Stores/IbsSurveyStore'
import sharedStore from '../../components/Stores/SharedStore'
import { assetsContainsAC } from '../../helpers'
import { SurveyTypeURL, CommonResponses } from '../../Enums/constants'
import store from '../../components/Stores/SurveyStore'
import { getSurveyResponseValue } from './SurveyResponsesHelper'


function evaluateNumericCondition(condition, valueNum) {
  if (condition.hasOwnProperty("gt") && !(valueNum > condition.gt)) return true;
  if (condition.hasOwnProperty("gte") && !(valueNum >= condition.gte)) return true;
  if (condition.hasOwnProperty("lt") && !(valueNum < condition.lt)) return true;
  if (condition.hasOwnProperty("lte") && !(valueNum <= condition.lte)) return true;
  if (condition.hasOwnProperty("eq") && !(valueNum === condition.eq)) return true;

  return false
}


//basically conditionList.includes(response), but handles CommonResponse logic as well as OR/AND
//if allowAnyMatch is never encountered, the opposite will be returned
//use TRUE for OR logic and FALSE for AND logic
function stringResponseMatch(conditionList, response, allowAnyMatch) {
  for (const condition of conditionList) {
    switch (condition) {
      case (CommonResponses.NOT_NA):
        if ((store.local.naList.indexOf(response) === -1) === allowAnyMatch) return allowAnyMatch;
        break;
      case (CommonResponses.NOT_UNKNOWN):
        if ((store.local.unknownList.indexOf(response) === -1) === allowAnyMatch) return allowAnyMatch;
        break;
      case (CommonResponses.NOT_NA_UNKNOWN):
        if ((store.local.naList.indexOf(response) === -1 && store.local.unknownList.indexOf(response) === -1) === allowAnyMatch) return allowAnyMatch;
        break;
      case (CommonResponses.NOT_ZERO):
        let responseAsNum = response * 1
        if (((!isNaN(responseAsNum) && responseAsNum !== 0)) === allowAnyMatch) return allowAnyMatch;
        break;
      case (CommonResponses.NA):
        if ((store.local.naList.indexOf(response) !== -1) === allowAnyMatch) return allowAnyMatch;
        break;
      case (CommonResponses.UNKNOWN):
        if ((store.local.unknownList.indexOf(response) !== -1) === allowAnyMatch) return allowAnyMatch;
        break;
      default:
        //do a direct string comparison
        if ((condition === response) === allowAnyMatch) return allowAnyMatch;
    }
  }

  //will return TRUE if using AND logic (all matched), and FALSE if using OR logic (none matched)
  return !allowAnyMatch
}

export function hiddenContentCheck(props) {
  const hide = true
  const show = false
  let toHide = null
  if (
    store.surveyTypeUrl === SurveyTypeURL.DC ||
    store.surveyTypeUrl === SurveyTypeURL.DB
  )
    toHide = checkIBSHiddenContent(props)
  if (toHide) return toHide

  if (
    props.showIf &&
    typeof props.showIf === 'object' &&
    !Array.isArray(props.showIf)
  ) {
    // showIf can we use like
    //  showIf = {{
    //      AdminSystemInHouseThirdParty: ["thirdparty", "both"],
    //      OR
    //      UsesExternalConsultant: { not: "yes" }
    //  }}

    // OR logic: if "or" key is present and is an array of condition objects
    const orKey = Object.keys(props.showIf).find(k => k.toLowerCase() === "or");
    if (orKey && Array.isArray(props.showIf[orKey])) {
      for (const orCondition of props.showIf[orKey]) {
          let allMatch = true;
          for (const [question, condition] of Object.entries(orCondition)) {
              const actualValue = getSurveyResponseValue(question, null);
              if (actualValue === null || actualValue === undefined) {
                  allMatch = false;
                  break;
              }
              const actualStr = actualValue.toString().toLowerCase();
    
              if (typeof condition === "string" || Array.isArray(condition)) {
                  const expectedValues = (Array.isArray(condition) ? condition : [condition])
                      .map(v => v?.toString().toLowerCase?.());
                  if (!stringResponseMatch(expectedValues, actualStr, true)) {
                      allMatch = false;
                      break;
                  }
              } else if (typeof condition === "object" && condition.hasOwnProperty("not")) {
                  const notValues = (Array.isArray(condition.not) ? condition.not : [condition.not])
                      .map(v => v?.toString().toLowerCase?.());
                  if (stringResponseMatch(notValues, actualStr, true)) {
                      allMatch = false;
                      break;
                  }
              } else if (typeof condition === "object" &&
                  (
                      condition.hasOwnProperty("gt") ||
                      condition.hasOwnProperty("gte") ||
                      condition.hasOwnProperty("lt") ||
                      condition.hasOwnProperty("lte") ||
                      condition.hasOwnProperty("eq")
                  )
              ) {
                  let valueNum = Number(actualValue);
                  if (!isNaN(valueNum) && evaluateNumericCondition(condition, valueNum)) {
                      allMatch = false;
                      break;
                  }
              } else {
                  console.warn(`Unsupported format in 'showIf' for ${question}:`, condition);
                  allMatch = false;
                  break;
              }
          }
          if (allMatch) return show; // If any OR group matches, show
      }
      return hide; // None matched
    }

    // Default AND logic
    for (const [question, condition] of Object.entries(props.showIf)) {
        
        // skip the "or" key if present
        if (question.toLowerCase() === "or") continue;
        
        const actualValue = getSurveyResponseValue(question, null)
        if (actualValue === null || actualValue === undefined) 
          return hide
        
        const actualStr = actualValue.toString().toLowerCase();

        if (typeof condition === "string" || Array.isArray(condition)) {
            const expectedValues = (Array.isArray(condition) ? condition : [condition])
                .map(v => v?.toString().toLowerCase?.());
            if (!stringResponseMatch(expectedValues, actualStr, true)) return hide;
        } else if (typeof condition === "object" && condition.hasOwnProperty("not")) {
            const notValues = (Array.isArray(condition.not) ? condition.not : [condition.not])
                .map(v => v?.toString().toLowerCase?.());
            if (stringResponseMatch(notValues, actualStr, true)) return hide;
        } else if (typeof condition === "object" &&
            (
                condition.hasOwnProperty("gt") ||
                condition.hasOwnProperty("gte") ||
                condition.hasOwnProperty("lt") ||
                condition.hasOwnProperty("lte") ||
                condition.hasOwnProperty("eq")
            )
        ) {
            let valueNum = Number(actualValue);
            if (!isNaN(valueNum) && evaluateNumericCondition(condition, valueNum)) {
                return hide;
            }
        } else {
            console.warn(`Unsupported format in 'showIf' for ${question}:`, condition);
            return hide;
        }
        
    }

    return show // all conditions matched → show
  }
 
  //multiple desired values (ex unknown, n/a)
  var desiredValueList = []
  if (props.desiredValue && !Array.isArray(props.desiredValue)) {
    desiredValueList.push(props.desiredValue.toString())
  } else if (props.desiredValue) {
    desiredValueList = props.desiredValue.map((v) => v.toString().toLowerCase())
  }

  //if there are multiple dependent Questions
  if (
    props.dependentQuestion &&
    props.dependentQuestion.length > 1 &&
    Array.isArray(props.dependentQuestion)
  ) {
    for (const element of props.dependentQuestion) {
      var actualValue = getSurveyResponseValue(element, null)

      // First maintain the greaterValue logic
      if (
        actualValue != null &&
        props.greaterValue != null &&
        actualValue > props.greaterValue
      ) {
        return show
      }

      // Extend the desired value to also work with an arry of results
        for (const desiredValue of desiredValueList) {
            //works for pabs
            if (
                actualValue != null &&
                props.desiredValue != null &&
                (actualValue == CommonResponses.BLANK||
                    stringResponseMatch([desiredValue.toLowerCase()], actualValue.toLowerCase(), true))
        ) {
          return show
        }
      }
    }
    return hide
  }

  //reliant on dependent questions response value
  // Sometimes blank values are used to show
  var dependentValue = getSurveyResponseValue(props.dependentQuestion, null)

  if (
    props.dependentQuestion &&
    (dependentValue === null || dependentValue === '') &&
    !desiredValueList.includes(CommonResponses.BLANK)
  ) {
    return hide
  }

  if (
    dependentValue != '' &&
    !isNaN(props.greaterValue) &&
    dependentValue > props.greaterValue
  ) {
    return show
  } else if (
    dependentValue != '' &&
    !isNaN(props.lessThanValue) &&
    dependentValue < props.lessThanValue
  ) {
    return show
  }
  if (
    typeof dependentValue == 'string' &&
    (props.dependentQuestion === null || dependentValue === '')
  ) {
    return show
  } else if (dependentValue != null && dependentValue == props.desiredValue) {
    return show
  } else if (
    dependentValue &&
    desiredValueList.includes(dependentValue.toString().toLowerCase())
  ) {
    // && typeof (dependentValue) == "boolean"
    return show
  } else if (
    (dependentValue === undefined ||
      dependentValue === null ||
      (typeof dependentValue === 'string' &&
        dependentValue.toLowerCase() === 'null')) &&
    desiredValueList.includes(CommonResponses.BLANK)
  ) {
    return show
  }

  if (
    desiredValueList.includes(CommonResponses.NOT_ZERO) &&
    dependentValue != 0
  ) {
    return show
  }
  //desired value is not unknown NOR n/a
  if (
    (desiredValueList.includes(CommonResponses.NOT_UNKNOWN) &&
      store.local.unknownList.indexOf(dependentValue) == -1) ||
    (desiredValueList.includes(CommonResponses.NOT_NA) &&
      store.local.naList.indexOf(dependentValue) == -1)
  ) {
    return show
  }
  //desired value is not unknown AND not n/a
  if (
    desiredValueList.includes(CommonResponses.NOT_NA_UNKNOWN) &&
    store.local.naList.indexOf(dependentValue) == -1 &&
    store.local.unknownList.indexOf(dependentValue) == -1
  ) {
    return show
  }

  return hide
}

function checkIBSHiddenContent(props) {
  const hide = true
  const show = false
  let isHide = null
  //User related
  if (props.inUserDetails) {
    const propName = props.inUserDetails.propName
    const desiredValue = props.inUserDetails.value
    if (ibsStore.accountInfo && ibsStore.accountInfo[propName]) {
      if (ibsStore.accountInfo[propName] == desiredValue) return false
    }
    return true
  }

  //Survey related
  if (props.inSurveyDetails) {
    const propName = props.inSurveyDetails.propName
    const desiredValue = props.inSurveyDetails.value
    let operator = props.inSurveyDetails.operator
    if (operator === undefined || operator === null) {
      operator = '='
    }

    if (
      ibsStore.currentSurvey &&
      ibsStore.currentSurvey[propName] !== undefined
    ) {
      let shouldShow = false

      switch (operator) {
        case '=':
        case '==':
        case '===':
          if (desiredValue.length > 0)
            shouldShow = desiredValue.includes(ibsStore.currentSurvey[propName])
          else shouldShow = ibsStore.currentSurvey[propName] == desiredValue
          break
        case '!=':
          shouldShow = ibsStore.currentSurvey[propName] != desiredValue
          break
        case '!==':
          shouldShow = ibsStore.currentSurvey[propName] != desiredValue
          break
        case '<':
          shouldShow = ibsStore.currentSurvey[propName] < desiredValue
          break
        case '<=':
          shouldShow = ibsStore.currentSurvey[propName] <= desiredValue
          break
        case '>':
          shouldShow = ibsStore.currentSurvey[propName] > desiredValue
          break
        case '>=':
          shouldShow = ibsStore.currentSurvey[propName] >= desiredValue
          break
      }
      return shouldShow ? show : hide
    } else return hide
  }
  //reliant on a different variable (provided as 'props.dependent') AKA not based on a props.dependent question
  if (props.dependent && ibsStore.currentSurvey) {
    if (ibsStore.currentSurvey[props.dependent] == props.desiredValue) {
      return show
    }

    if (props.hideValue != undefined) {
      if (ibsStore.currentSurvey[props.dependent] == props.hideValue) {
        //hide for this value
        return hide
      } else {
        // show for everyone else
        return show
      }
    }

    if (props.greaterValue != undefined) {
      if (
        props.dependent &&
        ibsStore.currentSurvey[props.dependent] > props.greaterValue
      ) {
        //show for this value
        return show
      }
    }

    if (props.lessThanValue != undefined) {
      if (props.desiredValue < props.lessThanValue) {
        //show for this value
        return show
      }
    }

    //hide this content
    return hide
  }

  //Survey Data related
  if (props.hedgingCondition) {
    if (sharedStore.cultureIdentifier === 'en-us') {
      return hide
    }
    return show
  }

  if (props.bundledLDICondition) {
    //check filter

    let hasLDIAssets = ibsStore.allTableResponses['combinedAssets'].filter(
      (item) => {
        return item['AssetClassName'] == 'Bundled LDI'
      }
    ).length
    if (hasLDIAssets > 0) {
      return show
    }
    return hide
  }

  if (props.derivativesCondition) {
    if (assetsContainsAC(50) || assetsContainsAC(87)) {
      return show
    }
    return hide
  }

  isHide = checkPlanDesignHideStatus(props)
  if (isHide) return isHide

  // Expenses page conditional logic
  if (props.specialExpensesCondition) {
    var actualValue = getSurveyResponseValue('NumSupportFTE', null)
    var fundSize = getSurveyResponseValue('FundSize', null)
    if (ibsStore.isEnhanced) {
      //always show
      return show
    } else if (actualValue > 14 && fundSize > 5) {
      return show
    }
    return hide
  }

  if (props.specialExpensesConditionCIEBA) {
    if (ibsStore.isEnhanced) {
      //hide for enhanced internal
      return hide
    } else if (
      ibsStore.currentSurvey &&
      ibsStore.currentSurvey.PlanPartnershipID == 2
    ) {
      // show for CIEBA
      return show
    }

    return hide
  }

  if (props.specialExpensesConditionUK) {
    if (ibsStore.isEnhanced) {
      //hide for enhanced internal
      return hide
    } else if (
      ibsStore.currentSurvey?.CountryID &&
      ibsStore.currentSurvey.CountryID === 11
    ) {
      // show for UK
      return show
    }

    return hide
  }

  if (props.specialExpensesConditionNonCIEBA) {
    if (ibsStore.isEnhanced) {
      //hide for enhanced internal
      return hide
    } else if (
      ibsStore.currentSurvey &&
      ibsStore.currentSurvey.PlanPartnershipID != 2
    ) {
      // show for non CIEBA
      return show
    }

    return hide
  }

  if (props.specialLGPSDutchCondition) {
    if (ibsStore.currentSurvey?.PlanPartnershipID === 6) {
      return show
    }
    if (
      ibsStore.currentSurvey?.CountryID &&
      ibsStore.currentSurvey.CountryID === 3
    ) {
      return show
    }
    return hide
  }

  if (props.specialNonLGPSDutchCondition) {
    if (ibsStore.currentSurvey?.PlanPartnershipID === 6) {
      return hide
    }
    if (
      ibsStore.currentSurvey?.CountryID &&
      ibsStore.currentSurvey.CountryID === 3
    ) {
      return hide
    }
    return show
  }
  if (props.specialMandatesQuestion) {
    if (ibsStore.hasMandateData) return true
    else return show
  }
  //LIABILTY Conditional
  if (props.specialConditionNonCIEBALiability) {
    let response = getSurveyResponseValue('HasTwoPortfolio')
    let hasLDIAssets = ibsStore.allTableResponses['combinedAssets'].filter(
      (item) => {
        return item['AssetClassName'] == 'Bundled LDI'
      }
    ).length

    //Has bundled ldi
    if (
      ibsStore.currentSurvey &&
      ((ibsStore.currentSurvey.PlanPartnershipID != 2 &&
        (hasLDIAssets > 0 || response == 1)) ||
        (ibsStore.currentSurvey.PlanPartnershipID == 2 && hasLDIAssets > 0))
    ) {
      return show
    } else {
      return hide
    }
  }
  return null
}

function checkPlanDesignHideStatus(props) {
  let isHide = null
  // PlanDesign conditional logic
  var employeesWithDB = getSurveyResponseValue(
    'PlanDesignEmployeesWithDB',
    null
  )
  var differentRates = getSurveyResponseValue(
    'PlanDesignHasDifferentRates',
    null
  )

  if (props.specialPlanDesignTableCondition) {
    if (
      employeesWithDB.toString() === '1' ||
      employeesWithDB.toString() === '3' ||
      (employeesWithDB.toString() === '2' &&
        (differentRates.toString() === '0' ||
          differentRates.toString() === '1'))
    ) {
      return false
    }
    return true
  }

  if (props.specialPlanDesignFirstColumnCondition) {
    if (
      employeesWithDB.toString() === '3' ||
      (employeesWithDB.toString() === '2' &&
        (differentRates.toString() === '0' ||
          differentRates.toString() === '1'))
    ) {
      return false
    }
    return true
  }

  if (props.specialPlanDesignSecondColumnCondition) {
    if (
      employeesWithDB.toString() === '1' ||
      (employeesWithDB.toString() === '2' && differentRates.toString() === '1')
    ) {
      return false
    }
    return true
  }

  if (props.specialMDAutoEnrollAllCondition) {
    var first = getSurveyResponseValue('MDAutoEnroll', {
      participantType: 0,
    })
    var second = getSurveyResponseValue('MDAutoEnroll', {
      participantType: 1,
    })
    if (first != true && second != true) {
      return true //hide
    }
    return false
  }

  if (props.specialMDAutoEnrollFirstColumnCondition) {
    var first = getSurveyResponseValue('MDAutoEnroll', {
      participantType: 0,
    })
    //    console.log("MDAutoEnroll, participant 0 is " + first);
    if (
      first == true &&
      (employeesWithDB.toString() === '3' ||
        (employeesWithDB.toString() === '2' &&
          (differentRates.toString() === '0' ||
            differentRates.toString() === '1')))
    ) {
      return false // show
    }
    return true
  }

  if (props.specialMDAutoEnrollSecondColumnCondition) {
    var second = getSurveyResponseValue('MDAutoEnroll', {
      participantType: 1,
    })
    //    console.log("MDAutoEnroll, participant 1 is " + second);
    if (
      second == true &&
      (employeesWithDB.toString() === '1' ||
        (employeesWithDB.toString() === '2' &&
          differentRates.toString() === '1'))
    ) {
      return false // show
    }
    return true
  }

  if (props.specialEEHasFixedAllCondition) {
    var first = getSurveyResponseValue('EE_HasFixed', {
      participantType: 0,
    })
    var second = getSurveyResponseValue('EE_HasFixed', {
      participantType: 1,
    })

    if (first != true && second != true) {
      return true //hide
    }
    return false
  }

  if (props.specialEEHasFixedFirstColumnCondition) {
    var first = getSurveyResponseValue('EE_HasFixed', {
      participantType: 0,
    })
    if (
      first == true &&
      (employeesWithDB.toString() === '3' ||
        (employeesWithDB.toString() === '2' &&
          (differentRates.toString() === '0' ||
            differentRates.toString() === '1')))
    ) {
      return false // show
    }
    return true
  }

  if (props.specialEEHasFixedSecondColumnCondition) {
    var second = getSurveyResponseValue('EE_HasFixed', {
      participantType: 1,
    })
    if (
      second == true &&
      (employeesWithDB.toString() === '1' ||
        (employeesWithDB.toString() === '2' &&
          differentRates.toString() === '1'))
    ) {
      return false // show
    }
    return true
  }

  if (props.specialERHasFixedAllCondition) {
    var first = getSurveyResponseValue('ER_HasFixed', {
      participantType: 0,
    })
    var second = getSurveyResponseValue('ER_HasFixed', {
      participantType: 1,
    })
    if (first != true && second != true) {
      return true //hide
    }
    return false
  }

  if (props.specialERHasFixedFirstColumnCondition) {
    var first = getSurveyResponseValue('ER_HasFixed', {
      participantType: 0,
    })
    if (
      first == true &&
      (employeesWithDB.toString() === '3' ||
        (employeesWithDB.toString() === '2' &&
          (differentRates.toString() === '0' ||
            differentRates.toString() === '1')))
    ) {
      return false // show
    }
    return true
  }

  if (props.specialERHasFixedSecondColumnCondition) {
    var second = getSurveyResponseValue('ER_HasFixed', {
      participantType: 1,
    })
    if (
      second == true &&
      (employeesWithDB.toString() === '1' ||
        (employeesWithDB.toString() === '2' &&
          differentRates.toString() === '1'))
    ) {
      return false // show
    }
    return true
  }

  if (props.specialBeforeAfterTaxAllCondition) {
    var firstCC = getSurveyResponseValue('CMMatchC', { participantType: 0 })
    var secondCC = getSurveyResponseValue('CMMatchC', { participantType: 1 })
    var firstAT = getSurveyResponseValue('HasAfterTaxEmployerMatch', {
      participantType: 0,
    })
    var secondAT = getSurveyResponseValue('HasAfterTaxEmployerMatch', {
      participantType: 1,
    })

    if (
      firstCC != true &&
      secondCC != true &&
      firstAT != true &&
      secondAT != true
    ) {
      return true //hide
    }
    return false
  }

  if (props.specialBeforeAfterTaxFirstColumnCondition) {
    var firstCC = getSurveyResponseValue('CMMatchC', { participantType: 0 })
    var firstAT = getSurveyResponseValue('HasAfterTaxEmployerMatch', {
      participantType: 0,
    })
    if (
      (firstCC == true || firstAT == true) &&
      (employeesWithDB.toString() === '3' ||
        (employeesWithDB.toString() === '2' &&
          (differentRates.toString() === '0' ||
            differentRates.toString() === '1')))
    ) {
      return false // show
    }
    return true
  }

  if (props.specialBeforeAfterTaxSecondColumnCondition) {
    var secondCC = getSurveyResponseValue('CMMatchC', { participantType: 1 })
    var secondAT = getSurveyResponseValue('HasAfterTaxEmployerMatch', {
      participantType: 1,
    })
    if (
      (secondCC == true || secondAT == true) &&
      (employeesWithDB.toString() === '1' ||
        (employeesWithDB.toString() === '2' &&
          differentRates.toString() === '1'))
    ) {
      return false // show
    }
    return true
  }
  return isHide
}
